// noinspection JSUnusedGlobalSymbols

import Helper from '../../../client/helper'
import {Calendar} from '@fullcalendar/core'
import DayGridPlugin from '@fullcalendar/daygrid'
import InteractionPlugin from '@fullcalendar/interaction'
import FullCalendarJa from '@fullcalendar/core/locales/ja'

// noinspection JSFileReferences
import SweetAlert2 from 'sweetalert2/dist/sweetalert2.min.js'

export default class
{
	static init()
	{
		const time = {}

		const edit = (date) =>
		{
			const input = {
				start_hour  : time[date].start ? time[date].start.split(/:/)[0] : '',
				start_minute: time[date].start ? time[date].start.split(/:/)[1] : '',
				end_hour    : time[date].end ? time[date].end.split(/:/)[0] : '',
				end_minute  : time[date].end ? time[date].end.split(/:/)[1] : '',
				open        : time[date].open,
			}

			const option = {start: '', end: ''}

			for(let hour = 7; hour <= 23; hour++)
			{
				option.start += `<option${hour === Number(input.start_hour) ? ' selected' : ''}>${hour}</ooption>`
				option.end += `<option${hour === Number(input.end_hour) ? ' selected' : ''}>${hour}</ooption>`
			}

			SweetAlert2.fire({
				html             : `
<div>
	${date.replace(/^(\d+)-0?(\d+)-0?(\d+)$/, `$1${Helper.message('#message-year')}$2${Helper.message('#message-month')}$3${Helper.message('#message-day')}`)}
</div>
<form id="time" class="mt-1">
	<input type="hidden" name="date" value="${date}">
	<div class="pretty p-switch p-fill">
		<input type="checkbox" name="open" value="1"${input.open ? ' checked' : ''}>
		<div class="state">
			<label>${Helper.message('#message-open')}</label>
		</div>
	</div>
	
	<select name="start_hour">
	${option.start}
	</select>
	:
	<select name="start_minute">
		<option value="00">00</option>
		<option value="30"${input.start_minute === '30' ? ' selected' : ''}>30</option>
	</select>
	〜
	<select name="end_hour">
	${option.end}
	</select>
	:
	<select name="end_minute">
		<option value="00">00</option>
		<option value="30"${input.end_minute === '30' ? ' selected' : ''}>30</option>
	</select>
</form>
`,
				showCancelButton : true,
				confirmButtonText: Helper.message('#message-ok'),
				cancelButtonText : Helper.message('#message-cancel'),
				showClass        : {
					popup: 'animate__animated animate__fadeIn animate__faster',
				},
			}).then((result) =>
			{
				if(!result.isConfirmed) return

				const start = $('#time select[name="start_hour"]').val() + ':' + $('#time select[name="start_minute"]').val()
				const end = $('#time select[name="end_hour"]').val() + ':' + $('#time select[name="end_minute"]').val()

				const open = $('#time input[name="open"]')[0].checked ? '1' : '0'
				const date = $('#time input[name="date"]').val()

				App.common.Ui.post('/open/', {
					__action: 'open',
					date    : date,
					open    : open,
					start   : start,
					end     : end,
				}, App.common.Ui.reload)
			})
		}

		const language = Helper.language() === 'ja' ? FullCalendarJa : undefined

		const calendar = new Calendar($('#calendar')[0], {
			plugins             : [DayGridPlugin, InteractionPlugin],
			initialView         : 'dayGridMonth',
			locale              : language,
			height              : 'auto',
			showNonCurrentDates : false,
			firstDay            : 1,
			headerToolbar       : {
				left  : 'prev',
				center: 'title',
				right : 'next',
			},
			events              : '/open/open_list',
			eventBackgroundColor: '#e88',
			eventBorderColor    : '#e88',
			eventContent        : (info) =>
			{
				return {html: info.event.title}
			},
			eventsSet           : (list) =>
			{
				for(const info of list) time[info.startStr] = info.extendedProps
			},
			eventClick          : (event) =>
			{
				edit(event.event.startStr)
			},
			dateClick           : (info) =>
			{
				edit(info.dateStr)
			},
		})

		calendar.render()
	}

	static change_day(weekday, checked)
	{
		for(const name of ['start_hour', 'start_minute', 'end_hour', 'end_minute'])
		{
			if(checked) $(`#row_${weekday}`).removeClass('bg-neutral-200')
			else $(`#row_${weekday}`).addClass('bg-neutral-200')
		}
	}
}
